import React from 'react';
import solutionSvg from '../../assets/icons/solution-icon.svg';

interface SolutionIconProps {
  size?: number;
  className?: string;
}

const SolutionIcon: React.FC<SolutionIconProps> = ({ size = 48, className = '' }) => {
  return (
    <img 
      src={solutionSvg} 
      alt="Solution Icon"
      width={size}
      height={size}
      className={className}
      style={{ filter: 'url(#orangeToPinkGradient)' }}
    />
  );
};

export default SolutionIcon;
